var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadFirmwareArrow = function SvgUploadFirmwareArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M1.5 19.5v3a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3v-3m-18-12 6-6m0 0 6 6m-6-6v18"
  })));
};
export { SvgUploadFirmwareArrow as ReactComponent };
export default __webpack_public_path__ + "bcd347bb598aae410d50f51c95fb75e6.svg";